module.exports = __webpack_public_path__ + "img/mk.90406666.svg";